<style>
.mapBtn{position: absolute;bottom: 10px;left: 30px;background-color: rgba(255,255,255,0);}
.mapType {position: relative;float: left; width: 102px; height: 75px; border-radius: 2px; cursor: pointer; margin: 4px;}
.checkBox {position: relative; top: 3px; right: 3px;float:right;z-index: 9999;}
.typeName {position: relative; top: 3px; right: 3px;float:right;color: white;background: #8a8888;}
.typeName.check {background: #e2971b;}
</style>

<template>
  <div class="mapBtn">
    <div v-for="btn in btnList" :key="btn.title" class="mapType" :style="{'background': `url(${btn.imgUrl})`, 'background-size': '100% 100%'}" @click="onClick(btn)">
      <span class="typeName" :class="{check: btn.isCheck}">{{btn.title}}</span>
    </div>
  </div>
</template>

<script>
/** 组件 - 地图按钮 */

export default
{
  props:
  {
    maplayer: {type: Array}
  },
  data()
  {
    return {
      btnList: [
        {title: '地形底图', isCheck: false, imgUrl: 'static/index/地形图.jpg'},
        {title: '矢量底图', isCheck: false, imgUrl: 'static/index/矢量图.png'},
        {title: '卫星底图', isCheck: true, imgUrl: 'static/index/卫星图.png'}
      ],
      curBtn: null
    }
  },
  mounted()
  {
    this.lyrs = {}
  },
  methods:
  {
    /**
     * 按钮点击响应函数
     * @method
     * @param   {Object}   btn   按钮属性对象
     */
    onClick(btn)
    {
      this.btnList.forEach(item =>
      {
        item.isCheck = (item === btn) ? !item.isCheck : false
      })

      let index = this.maplayer.findIndex(e => e.name === btn.title)
      for (let i = 0; i < this.maplayer.length; i++)
      {
        if (i === index)
          window.map.getLayers()['array_'][index].setVisible(true)
        else
          window.map.getLayers()['array_'][i].setVisible(false)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/kyyzt/Mapbtn.vue